export default {
  ticketBooksLoading: false,
  ticketBooks: []
}
